(function () {
    /********************* Setup *********************/

    // find the section element via the script's data-id, so two instances never share a carousel
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[id="${sectionID}"]`);
    if (!section) {
        console.warn(`Section with ID ${sectionID} not found.`);
        return;
    }

    /********************* Init *********************/

    // pass elements rather than selector strings so the swiper only ever binds its own slides
    new Swiper(section.querySelector(".ymal-swiper-v2"), {
        slidesPerView: 4.5,
        slidesPerGroup: 4,
        loop: false,
        pagination: {
            el: section.querySelector(".ymal-pagination-v2"),
            clickable: true
        },
        navigation: {
            nextEl: section.querySelector(".ymal-next-v2"),
            prevEl: section.querySelector(".ymal-prev-v2")
        },

        grabCursor: true,

        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            1250: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            }
        }
    });
}());
